import {FormikFieldConfig, FormikFieldTypes, FormikRegexSettings} from '../../FormikForm';
import * as Yup from 'yup';
import {useTranslation} from 'react-i18next';
import {ValidationErrorType} from '../../../utils/formValidators';

const resetPasswordFormConfig = (): FormikFieldConfig[] => {
    const {t} = useTranslation();

    return [
        {
            name: 'username',
            autofocus: true,
            label: t('auth.formControls.email'),
            validation: Yup.string()
                .max(255)
                .required(`${t(ValidationErrorType.IS_REQUIRED)}`)
                .matches(FormikRegexSettings.EMAIL, `${t(ValidationErrorType.IS_EMAIL)}`),
            type: FormikFieldTypes.TEXT,
        },
        {
            name: 'resetPassword-button',
            label: t('auth.resetPassword.sendEmailButton'),
            type: FormikFieldTypes.SUBMIT_BUTTON,
            sx: {fontSize: '1.5rem'},
            validation: {},
        },
    ];
};
export default resetPasswordFormConfig;
